/**
 * Status oficiais do documento no fluxo de validação.
 *
 * Fonte única da verdade pra typing e iteração. Importar em qualquer
 * código que precise comparar/escrever/iterar o campo `status` de documento.
 *
 * Espelha api/supabase/functions/api/types/documento-status.ts.
 */
export const STATUS = {
  RECEBIDO: 'recebido',
  EM_ANALISE: 'em-analise',
  PENDENTE: 'pendente',
  APROVADO: 'aprovado',
  RECUSADO: 'recusado',
} as const

export type DocumentoStatus = typeof STATUS[keyof typeof STATUS]

/** Lista imutável dos 5 status (útil pra iteração e validação). */
export const DOCUMENTO_STATUS_VALUES = Object.values(STATUS) as readonly DocumentoStatus[]
